import React from 'react';
import Link from 'next/link';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Button component.
 * @param param0 
 * @returns 
 */
export const AnchorLink: React.FunctionComponent<{
    href: string;
    icon?: IconDefinition;
    className?: string;
    onClick?: () => void;
    openNewTab?: boolean;
    disabled?: boolean;
}> = function ({ href, children, icon, className, openNewTab = false, onClick, disabled }) {

    const renderTarget = () => {
        if (openNewTab === true) {
            return '_blank';
        } else {
            return '';
        }
    }

    const renderClassName = () => {
        let className = '';

        if (disabled === true) {
            className += 'disabled ';
        }

        return className;
    }

    const renderButton = () => {
        // dont provide component children if using icon
        if (icon) {
            return (
                <a className={"text-decoration-none " + renderClassName() + className} target={renderTarget()} onClick={onClick}>
                    <div className="d-flex flex-row align-items-center">
                        <div>
                            <FontAwesomeIcon size='sm' icon={icon}></FontAwesomeIcon>
                        </div>
                        <p className="m-0 ms-2">{children}</p>
                    </div>
                </a>
            )
        } else {
            return (
                <a className={"text-decoration-none " + renderClassName() + className} target={renderTarget()} onClick={onClick}>{children}</a>
            )
        }
    }

    return (
        <Link href={href}>
            {renderButton()}
        </Link>
    );
}
